import React from 'react';

function ParlayBuilder() {
  return (
    <div className="parlay-builder">
      <div className="container">
        <h2>Parlay Builder</h2>
        <p>Build and analyze custom parlays</p>
      </div>
    </div>
  );
}

export default ParlayBuilder;
